(() => {
  let r = new Map(),
    o = (i) => {
      let a = i.querySelector(".logo-list");
      if (a && "true" === a.getAttribute("data-desktop-animation")) {
        let t = a.querySelectorAll(".logo-list__item"),
          r = !1,
          o = !1,
          s =
            ("true" === a.getAttribute("data-repeat-desktop-animation") &&
              (r = !0),
            () => {
              t.forEach((e) => {
                (e.style.opacity = 0),
                  (e.style.transform = "translate3d(0, 15px, 0)"),
                  (e.style.transition = "");
              });
            }),
          n = () => {
            t.forEach((e) => {
              (e.style.opacity = 1),
                (e.style.transform = ""),
                (e.style.transition = "");
            });
          },
          e = new IntersectionObserver(
            (e) => {
              e.forEach((e) => {
                !r && o
                  ? n()
                  : e.isIntersecting
                    ? (t.forEach((e, t) => {
                        (e.style.transition = `all var(--duration-long) ease-in-out calc(150ms * ${t + 1})`),
                          (e.style.opacity = 1),
                          (e.style.transform = "none");
                      }),
                      (o = !0))
                    : s();
              });
            },
            { threshold: 1 },
          );
        i = () => {
          576 <= document.body.clientWidth
            ? ((!r && o) || s(), e.observe(a))
            : (n(), e.unobserve(a), e.disconnect());
        };
        i(), window.addEventListener("resize", i);
      }
    },
    s = (e) => {
      var t = e.el,
        r = t.querySelector(".swiper-wrapper");
      r &&
        ((r = Array.from(r.children).reduce((e, t) => e + t.offsetWidth, 0)),
        t.offsetWidth < r ? e.setGrabCursor() : e.unsetGrabCursor());
    };
  window.addEventListener("resize", () => {
    r.forEach((e) => {
      s(e);
    });
  });
  let t = (t) => {
    t &&
      t.classList.contains("section-logo-list") &&
      new IntersectionObserver((e) => {
        e.forEach((e) => {
          e.isIntersecting &&
            (((e) => {
              let t = e.querySelector(".js-slider-logos");
              t &&
                new Swiper(t, {
                  slidesPerView: "auto",
                  loop: !1,
                  speed: 800,
                  mousewheel: { forceToAxis: !0 },
                  grabCursor: !0,
                  navigation: {
                    prevEl: t.parentNode.querySelector(".swiper-button-prev"),
                    nextEl: t.parentNode.querySelector(".swiper-button-next"),
                  },
                  breakpoints: { 1200: { mousewheel: !0, grabCursor: !0 } },
                  on: {
                    init: function () {
                      s(this), r.set(t, this);
                    },
                  },
                });
            })(t),
            o(t));
        });
      }).observe(t);
  };
  t(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      t(e.target);
    });
})();
